<script>
  export default {
    name: 'RenderCell',
    functional: true,
    props: {
      row: Object,
      render: Function,
      index: Number,
      column: Object
    },
    render: (h, ctx) => {
      const params = {
        row: ctx.props.row,
        index: ctx.props.index
      };
      params.column = ctx.props.column;
      return ctx.props.render(h, params);
    }
  };
</script>




// WEBPACK FOOTER //
// RenderCell.vue?66b550b4